
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as GrowIconComponent } from "./grow-icon.svg";

export const GrowIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <GrowIconComponent {...props} />;
};
